<template>
  <div class="container header-search">
    <div style="display: inline-block" class="searchIcon" @click="emitSearch">
      <el-image
        style="display: inline-table"
        class="image__dimension"
        :src="images.search.src"
        :fit="'contain'"
      />
    </div>
    <div style="" class="search-input">
      <el-input
        ref="searchInput"
        v-model="searchText"
        :placeholder="placeholder"
        @keyup.native.enter="emitSearch"
        :class="[isRestaurant && 'is-restaurant-search', isRestaurantDetail && 'is-restaurant-search']"
      />
    </div>
    <div style="display: inline-block" class="searchIcon" @click="emitClose">
      <el-image
        style="display: inline-table"
        class="image__dimension"
        :src="isRestaurant || isRestaurantDetail ? images.closeRestro.src : images.close.src"
        :fit="'contain'"
      />
    </div>
  </div>
</template>

<script>
import imgSearch from "@/assets/images/navbar/navbar-search-light.svg";
import imgClose from "@/assets/images/navbar/navbar-close.svg";
import imgCloseRestaurant from "@/assets/images/navbar/navbar-close-restaurant.svg";
import cssVariables from "@/assets/variables.scss";

export default {
  data() {
    return {
      searchText: "",
      placeholder: this.$i18n.t("common.navbar.searchInput.placeholder"),
      images: {
        search: {
          src: imgSearch,
        },
        close: {
          src: imgClose,
        },
        closeRestro: {
          src: imgCloseRestaurant
        },
      },
    };
  },
  computed: {
    isRestaurant(){
      return this.$route && this.$route.fullPath.indexOf('inventory=') > -1 ? true : false;
    },
    isRestaurantDetail() {
      return this.$route && this.$route.fullPath.indexOf('productType=') > -1  ? true : false;
    }
  },
  mounted() {
    this.$refs.searchInput.$el.children[0].style.cssText =
      "height:30px !important; line-height: 30px !important;" +
      `margin-top: 9px; background-color: ${cssVariables.colorPrimary}; border: 0; color: ${cssVariables.colorBackground}; caret-color: ${cssVariables.colorOnPrimary}#FFFFFF;`;

    this.setFocus();
  },
  methods: {
    setFocus() {
      this.$nextTick(() => this.$refs.searchInput.focus());
    },
    getSpanSize() {
      switch (this.$mq) {
        case "sm":
          return 22;
        case "md":
          return 14;
        case "lg":
        default:
          return 10;
      }
    },
    getOffsetSize() {
      switch (this.$mq) {
        case "sm":
          return 1;
        case "md":
          return 5;
        case "lg":
        default:
          return 7;
      }
    },
    emitSearch() {
      this.$emit("search-text-change", {
        text: this.searchText,
      });
    },
    emitClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";

i {
  color: $color-on-primary;
}
.searchIcon {
  cursor: pointer;
  height: 30px;
}
.image__dimension {
  width: 20px;
  height: 20px;
}
</style>
